import { Currency } from '@/core/currency/interfaces';

const MXN: Currency = {
    name: 'Mexican Peso',
    demonym: 'Mexican',
    majorSingle: 'Peso',
    majorPlural: 'Pesos',
    codeNumeric: '484',
    symbol: 'MX$',
    symbolNative: '$',
    minorSingle: 'Centavo',
    minorPlural: 'Centavos',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'MXN',
    delimiters: {
        thousands: ',',
        decimal: '.'
    }
};

export default MXN;
